<template>
  <div>
      <DefSlider
          :nav="true"
          :settings="settings"
          ref="slider"
      >
          <div
              v-for="item in result"
              :key="item.offer && item.offer.id || item.id"
              class="swiper-slide"
          >
              <SliderCard :result="item" :messages="messages" @addToBasket="forwardAddToCart" />
          </div>
      </DefSlider>
  </div>
</template>

<script>
import DefSlider from "../Def/DefSlider/DefSlider.vue";
import SliderCard from "../card/SliderCard/SliderCard.vue";

export default {
    name: 'BuyComplectSlider',
  components: {SliderCard, DefSlider},
    selector: '.buy-complect-slider',
    props: ['result', 'messages'],
    data() {
        return {
            settings: {
                slidesPerView: 2,
                spaceBetween: 0
            },
        }
    },
  methods: {
    forwardAddToCart(productId) {
      this.$emit('addToBasket', productId);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>